import { api } from './client.js';

export const fetchLookbookCollections = (store) =>
  api.get('/lookbooks/collections', { params: { store } }).then((r) => r.data.collections);
export const fetchLookbookProducts = ({ store, q, cursor }) =>
  api.get('/lookbooks/products', { params: { store, q: q || undefined, cursor: cursor || undefined } }).then((r) => r.data);
export const previewLookbook = (body) => api.post('/lookbooks/preview', body).then((r) => r.data);
export const generateLookbook = (body) =>
  api.post('/lookbooks/generate', body, { responseType: 'blob' }).then((r) => r.data);
export const sendLookbook = (body) => api.post('/lookbooks/send', body).then((r) => r.data);
export const fetchLookbookSends = () => api.get('/lookbooks/sends').then((r) => r.data.sends);
export const fetchLookbookContacts = () => api.get('/lookbooks/contacts').then((r) => r.data.contacts);
export const fetchCollectionProducts = (store, collectionId) =>
  api.get('/lookbooks/collection-products', { params: { store, collectionId } }).then((r) => r.data);
export const fetchLookbookRecipients = () => api.get('/lookbooks/recipients').then((r) => r.data);
export const draftLookbookMessage = (body) => api.post('/lookbooks/draft-message', body).then((r) => r.data);

export const rewriteLookbookCopy = ({ source, collection, file }) => {
  const fd = new FormData();
  if (source) fd.append('source', source);
  if (collection) fd.append('collection', collection);
  if (file) fd.append('file', file);
  return api.post('/lookbooks/rewrite-copy', fd).then((r) => r.data);
};
